import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=539a35c6&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539a35c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('539a35c6')) {
      api.createRecord('539a35c6', component.options)
    } else {
      api.reload('539a35c6', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=539a35c6&scoped=true&", function () {
      api.rerender('539a35c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2qxQ48fZ0VYR9/JS/comp/Accordion.vue"
export default component.exports